import { Selector } from "@ngxs/store";
import { BalancesState, BalancesStateModel } from "./balances.state";

export class BalancesSelectors {
    @Selector([BalancesState])
    static isLoading (state: BalancesStateModel) {
        return state.isLoading
    }
    @Selector([BalancesState])
    static error (state: BalancesStateModel) {
        return state.error
    }
    @Selector([BalancesState])
    static balance (state: BalancesStateModel) {
        return state.balance;
    }
}